import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { AjaxLeadFormModel } from '../../models/globals';
import { leadCreationFailedText } from '../../pages/lead-creation-error/App';
import { AjaxLeadForm } from '../common/AjaxLeadForm';
import { leadFormHeading } from '../common/LeadForm';

enum LeadFormStatus {
    UNSUBMITTED,
    LEAD_CREATION_SUCCESS,
    LEAD_CREATION_FAILED,
}

interface CtpLeadModalProps {
    onHide(): void;
    leadFormModel: AjaxLeadFormModel;
    show: boolean;
}

const CtpLeadModal: React.FC<CtpLeadModalProps> = ({ onHide, leadFormModel, show }) => {
    const [leadSubmitStatus, setLeadSubmitStatus] = React.useState<LeadFormStatus>(LeadFormStatus.UNSUBMITTED);

    return (
        <Modal
            contentClassName="p-3"
            dialogClassName="ctp-lead-modal"
            onHide={() => {
                setLeadSubmitStatus(LeadFormStatus.UNSUBMITTED);
                onHide();
            }}
            show={show}
        >
            <Modal.Header className="border-0" closeButton>
                <Modal.Title as="h1" className="h4" id="ModalLabel">
                    {
                        {
                            [LeadFormStatus.UNSUBMITTED]: leadFormHeading,
                            [LeadFormStatus.LEAD_CREATION_SUCCESS]: 'Thanks for reaching out!',
                            [LeadFormStatus.LEAD_CREATION_FAILED]: leadCreationFailedText.header,
                        }[leadSubmitStatus]
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body id="contactUsModalBody">
                {
                    {
                        [LeadFormStatus.UNSUBMITTED]: (
                            <AjaxLeadForm
                                {...leadFormModel}
                                errorPath={null} // override leadFormModel.errorPath to prevent client-side redirects in modal
                                formName="product"
                                onLeadCreationError={() => setLeadSubmitStatus(LeadFormStatus.LEAD_CREATION_FAILED)}
                                onLeadCreationSuccess={() => setLeadSubmitStatus(LeadFormStatus.LEAD_CREATION_SUCCESS)}
                                successPath={null} // override leadFormModel.successPath to prevent client-side redirects in modal
                            />
                        ),
                        [LeadFormStatus.LEAD_CREATION_SUCCESS]: (
                            <>
                                <h2 className="h6">We will call you within the next business day.</h2>
                                <h2 className="h6">Business hours are Monday to Friday, 9am to 9pm Eastern Time.</h2>
                            </>
                        ),
                        [LeadFormStatus.LEAD_CREATION_FAILED]: leadCreationFailedText.content,
                    }[leadSubmitStatus]
                }
            </Modal.Body>
        </Modal>
    );
};

export { CtpLeadModal, CtpLeadModalProps };
